<template>
    <div v-if="step < 5" class="step-heading__container">
        <h2 class="step-heading">Step {{ stepNumber - 1 }} of 3 - {{ stepName }}</h2>
        <div class="step-bar">
            <span class="step-bar__step" :class="stepClass(2)"><img :src="image(2)" alt="" class="step-bar__step--icon" /></span>
            <span class="step-bar__step" :class="stepClass(3)"><img :src="image(3)" alt="" class="step-bar__step--icon" /></span>
            <span class="step-bar__step" :class="stepClass(3)"><img :src="image(3)" alt="" class="step-bar__step--icon" /></span>
        </div>
    </div>

    <div v-else class="step-heading__container">
        <div class="step-bar__title-area">
            <h2 class="step-heading">Step {{ stepNumber - 5 }} of 5 - {{ stepName }}</h2>
        </div>
        <div class="step-bar">
            <span class="step-bar__step" :class="stepClass(6)"><img :src="image(6)" alt="" class="step-bar__step--icon" /></span>
            <span class="step-bar__step" :class="stepClass(7)"><img :src="image(7)" alt="" class="step-bar__step--icon" /></span>
            <span class="step-bar__step" :class="stepClass(8)"><img :src="image(8)" alt="" class="step-bar__step--icon" /></span>
            <span class="step-bar__step" :class="stepClass(9)"><img :src="image(9)" alt="" class="step-bar__step--icon" /></span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

const stepToNameMap = {
    2: "Your car",
    3: "Your Details",
    4: "Your Valuation",
    5: "Your Valuation",
    6: "Vehicle condition",
    7: "Service History",
    8: "Mechanical condition",
    9: "Vehicle walkaround",
    10: "Final Valuation"
};

export default {
    computed: {
        ...mapState('ValuationTool', ['step', 'bookingDetails']),

        stepName() {
            return stepToNameMap[this.step] || "Unknown step";
        },
        stepNumber() {
            if (this.step === 5) {
                return this.step -= 1
            } else {
                return this.step
            }
        }
    },
    methods: {
        stepClass(stepNumber) {
            if (this.bookingDetails) {
                return 'step-bar__step--completed'
            } else {
                return {
                    'step-bar__step--active': this.step === stepNumber,
                    'step-bar__step--completed': this.step > stepNumber
                };
            }
        },
        image(stepNumber) {
            if (this.bookingDetails) {
                return "/images/valuation-tool/not-my-vehicle/green-tick.svg";
            }
            if (stepNumber < this.step) {
                return "/images/valuation-tool/not-my-vehicle/green-tick.svg";
            }
            
            if(stepNumber > 5){
                if(stepNumber < this.step + 1){
                    return "/images/valuation-tool/not-my-vehicle/blue-car.svg";
                }
            }else{
                return "/images/valuation-tool/not-my-vehicle/blue-car.svg";
            }   
        }
    }

}
</script>